<template>
  <div class="container_box">
    <!--面包屑导航-->
    <div class="breadcrumb_box">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in breadcrumbList" :key="index" :to="item.path ? item.path : ''">{{ item.name }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!--头部操作栏-->
    <div class="header_options_box">
      <div class="flex align-items-center">
        <span>{{ $t('key1004819') }}</span>
        <span class="font-weight-bold">{{ choiceSortingInfo.code }}</span>
        <span class="font-weight-bold ml10">{{ orderTypeObj[choiceSortingInfo.orderType] }}</span>
      </div>
      <div class="flex align-items-center">
        <Button size="small" class="ml30" @click="pickEndSortingBtn">{{ $t('key1004820') }}</Button>
      </div>
    </div>
    <!--主体内容-->
    <Row class="choiceSorting">
      <!--SKU 货品信息-->
      <Col span="15">
        <!--SKU/货品身份码-->
        <div class="skuInput_box">
          <span>{{ $t('key1004821') }}</span>
          <Input ref="curSku" :element-id="'sortingSku'"
            style="width:300px;marginLeft:15px;" @on-enter="clearSku();skuStart()">
          </Input>
        </div>
        <div class="choiceSortingInfo_box">
          <template v-if="showProductGoods && sku !== null && sku !==''">
            <div class="flex align-items-center justify-content-center mt10 mb20">
              <!-- 拣货框 -->
              <div :style="curBox.color" class="productBox">{{ curBox.boxNo }}</div>
              <!-- 全部分拣完成 -->
              <div v-if="isFinishStatus" class="ml30" style="width:300px;">
                <div class="flex align-items-center mb15">
                  <Icon
                    type="md-information-circle"
                    color="#169bd5"
                    class="font-size-40 ml10"
                    style="lineHeight:20px;">
                  </Icon>
                  <h2 class="font-size-22 ml10" style="color:#ff0000;">{{ $t('key1004822') }} </h2>
                </div>
                <p class="font-size-15 font-weight-bold" style="color:#ff0000;">
                  {{ $t('key1004817').replace('{pickingGoodsNo}', showNo) }}
                </p>
              </div>
            </div>
            <!-- 货品信息 -->
            <div class="productInfo_box">
              <div>
                <Tooltip placement="left" theme="light" :transfer="true" transfer-class-name="set_bigimg_style">
                  <img class="img_styles" :src="setImgPath(productGoods.pictureUrl)" @error="setErrorImg($event)" alt=""/>
                  <template #content>
                    <img :ref="'thumbnailImg'" @load="handlerOnloadImg('thumbnailImg')" v-if="productGoods.pictureUrl"
                      :src="setImgPath(productGoods.pictureUrl)" @error="setErrorImg($event)" alt=""/>
                  </template>
                </Tooltip>
              </div>
              <div>
                <div class="font-size-22 mt10 mb10 flex align-items-center">
                  <span>SKU：</span>
                  <span style="color:#008000;">{{ productGoods.sku }}</span>
                </div>
                <div class="font-size-22 mt10 mb10 flex align-items-center">
                  <span>{{ $t('key1002424') }}</span>
                  <span style="color:#008000;">{{ productGoods.title }}</span>
                </div>
              </div>
            </div>
          </template>
          <!-- 货品异常警告 -->
          <div class="warnBox" v-if="!showProductGoods && sku !== null && sku !== ''">
            <h2 class="title">{{ $t('key1004823') }}</h2>
            <div class="content">
              <h2>
                {{ $t('key1004818').replace('{sku}', sku) }}
              </h2>
              <div class="mt10 font-size-14">
                <div class="mb5">{{ $t('key1004824') }}</div>
                <span>{{ $t('key1004825') }}</span>
                <br/>
                <span>{{ $t('key1004826') }}</span>
                <div class="mt5">
                  {{ $t('key1004827') }}
                </div>
              </div>
            </div>
            <div class="warnBtn">
              {{ $t('key1004828') }}
            </div>
          </div>
        </div>
      </Col>
      <!--拣货单、出库单信息-->
      <Col span="9">
        <Tabs v-model="tabName" type="card" style="margin:15px 10px 0 10px;">
          <!--拣货单-->
          <TabPane name="pickTab" class="packTab_box" :label="$t('key1004796')">
            <h2 class="mt10 mb10 pl10">
              <span>{{ $t('key1004829') }}</span>
              <span style="color:#0000FF;">{{ showNo }}</span>
            </h2>
            <Table border height="300" :columns="pickGoodsColumn" :data="pickGoodsData"></Table>
          </TabPane>
          <!--出库单-->
          <TabPane ref="packTab" name="packTab" class="packTab_box" :label="outboundOrderName" :disabled="packDisabled">
            <h2 class="mt10 mb10 pl10">
              <span>{{ $t('key1004830') }} </span>
              <span style="color:#0000FF;" v-if="choiceSortingInfo.orderType === 'TEMU_P'">{{ curBox.boxData.packageCode }}</span>
              <span style="color:#0000FF;" v-else>{{ packageCodeList.join('、') }}</span>
            </h2>
            <div class="ml10 showBoxNo" :style="curBox.color" style="cursor: none;">{{ curBox.boxNo }}</div>
            <Table
              ref="tableDom"
              :highlight-row="false"
              :disabled-hover="true"
              border
              height="300"
              :row-class-name="rowClassName"
              :columns="deliveryOrderColumn"
              :data="curBox.boxData.sortingPackageGoodsResult">
            </Table>
            <div class="flex align-items-center justify-content-around mt30">
              <Button v-if="!curBox.replacedOrder" @click="restPackage">{{ $t('key1004831') }}</Button>
              <Button v-if="!curBox.replacedOrder" @click="removePackage">{{ $t('key1004832') }}</Button>
              <Button v-if="choiceSortingInfo.orderType === 'TEMU_S'" @click="printTemuMiddleLabelBtn">{{ $t('key1004833') }}</Button>
            </div>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
    <!--篮子/包裹-->
    <div class="boxs_conter">
      <Row>
        <!-- 左 -->
        <Col span="8">
          <template v-for="(item, index) in leftBoxs" v-if="leftBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('leftBoxs', index)">
              <div class="icon_styles" style="border-top: 15px solid #ed4014;"></div>
              <div class="font-weight-bold">{{ item.boxNo }}</div>
              <div v-if="choiceSortingInfo.orderType === 'TEMU_P'">{{ item.boxData ? item.boxData.packageCode : '' }}</div>
            </div>
            <div v-if="(index + 1) % leftCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
        <!-- 中 -->
        <Col span="8" style="borderLeft:5px solid #528ed5;paddingLeft:10px;">
          <template v-for="(item, index) in midBoxs" v-if="midBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('midBoxs',index)">
              <div class="icon_styles" style="border-top: 15px solid #ff9900"></div>
              <div class="font-weight-bold">{{ item.boxNo }}</div>
              <div v-if="choiceSortingInfo.orderType === 'TEMU_P'">{{ item.boxData ? item.boxData.packageCode : '' }}</div>
            </div>
            <div v-if="(index + 1) % midCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
        <!-- 右 -->
        <Col span="8" style="borderLeft:5px solid #528ed5;paddingLeft:10px;">
          <template v-for="(item, index) in rigBoxs" v-if="rigBoxsStatus">
            <div class="pickBox" :style="item.color" @click="showBoxInfo('rigBoxs',index)">
              <div class="icon_styles" style="border-top: 15px solid #2db7f5;"></div>
              <div class="font-weight-bold">{{ item.boxNo }}</div>
              <div v-if="choiceSortingInfo.orderType === 'TEMU_P'">{{ item.boxData ? item.boxData.packageCode : '' }}</div>
            </div>
            <div v-if="(index + 1) % rigCol === 0" style="float: none;height: 62px;" :key="item.boxNo"></div>
          </template>
        </Col>
      </Row>
    </div>
    <!-- 结束分拣有异常弹窗-->
    <endSortingModal ref="endSorting" @endsortingBtn="endsortingBtn"></endSortingModal>
    <!--订单取消提示-->
    <orderCancelPromptModal ref="orderCancelPrompt" @updateData="updateDeliveryData"></orderCancelPromptModal>
    <!--商品标签选择-->
    <Modal v-model="platformItemSkuLabelPathModal" :title="$t('key1004816')" :mask-closable="false"
      @on-visible-change="platformItemSkuLabelPathChange">
      <div class="flex align-items-center">
        <span>{{ $t('key1004834') }}</span>
        <Select v-model="platformItemSku" filterable style="width: 200px;">
          <Option v-for="item in ymsPackageGoodsDetailsList" :value="item.platformItemSku" :key="item.platformItemSku">{{ item.platformItemSku }}</Option>
        </Select>
      </div>
      <template #footer>
        <div style="text-align: center;">
          <Button type="primary" @click="platformItemSkuLabelPathBtn" :disabled="!platformItemSku">{{ $t('key1000320') }}</Button>
          <Button @click="platformItemSkuLabelPathModal=false">{{ $t('key1000112') }}</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import light from "@/components/mixin/sortingInfo_mixin";
import orderCancelPromptModal from "@/components/common/orderCancelPromptModal";
import endSortingModal from "@/views/yms/components/wms/exWarehouse/endSortingModal.vue";
import {downloadControl, ymsVerifyPicking, qs, getCommonSetting, printHtmlUrl} from "@/utils/common";

export default {
  name: "choiceSortingInfo",
  mixins: [Mixin, light],
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004788')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004789')},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002652'), path: '/wms/sorting'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004790')}
      ],
      choiceSortingInfo: {},
      orderTypeObj: {
        TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004791'),
        TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004792')
      },
      sku: null, // 输入sku
      pickGoodsColumn: [
        {
          title: 'NO',
          width: 70,
          type: 'index',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004793'),
          key: 'skuInfo',
          minWidth: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('div', {class: 'mt5 mb5', style: {color: '#008000'}}, params.row.sku),
              h('div', {class: 'mt5 mb5'}, params.row.title),
              h('div', {class: 'mt5 mb5'}, params.row.variations)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004794'), // 总货品数量
          key: 'quantity',
          minWidth: 100,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004795'), // 已分拣货品数量
          key: 'sortingQuantity',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', params.row.haveNum);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003991'), // 还需
          key: 'stillNeed',
          width: 70,
          align: 'center',
          render: (h, params) => {
            let num = params.row.quantity - params.row.haveNum;
            if (num) {
              return h('div', {
                style: {
                  color: '#FF0000'
                }
              }, num);
            } else {
              return h('div', {
                style: {
                  color: '#008000'
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002554'));
            }
          }
        }
      ],
      deliveryOrderColumn: [],
      leftBoxs: [], // 左侧货架
      midBoxs: [], // 中间货架
      rigBoxs: [], // 右侧货架
      leftBoxsStatus: true, // 拣货架状态
      midBoxsStatus: true,
      rigBoxsStatus: true,
      leftRow: null,
      leftCol: null,
      midRow: null,
      midCol: null,
      rigRow: null,
      rigCol: null,
      ymsPickingOrderId: null,
      showNo: null, // 拣货单
      packageData: [], // 出库单列表数据
      productGoods: { //  // 当前货品展示
        sku: null,
        title: null,
        pictureUrl: null
      },
      showProductGoods: false, // 控制是否显示当前货品信息（无效时用到）
      tabName: 'pickTab', // 控制标签页显示
      pickTab: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004796'),
      packTab: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004797'),
      packDisabled: true, // 控制出库单标签页的显示隐藏
      pickDataNum: 0, // 已完成扫描的货品数量
      isFinishStatus: false, // 全部分拣完成提示信息
      isFinish: false, // 分拣完成模态框
      finModalStatus: false, // 是否加载分拣完成模态框
      newPickingGoodsNo: null, // 开启新的拣货单
      curBox: {
        // 当前篮子
        boxData: {}
      },
      rowClassIndex: null, // 记录当前高亮行下标
      pickGoodsData: [], // 拣货单列表
      greenLightNum: null, // 记录已经完成分拣的篮子编号
      greenLightStatus: false, // 通过状态判断避免重复调用方法
      printUrl: '', // 打印地址
      clearTime: null,
      orderType: null,
      packageCodeList: [], // 样品订单的出库单
      packetList: [], // 扫描sku创建小包的数据
      createTalg: true, // 首次扫描sku时，创建小包的标识
      outboundOrderList: [], // 获取有效出库单数据

      ymsPackageGoodsDetailsList: [],
      platformItemSku: null,
      platformItemSkuLabelPathModal: false,
      sortingPackageGoodsResult: {}
    };
  },
  computed: {
    outboundOrderName() {
      let name = this.choiceSortingInfo.orderType === 'TEMU_S' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004798') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004797');
      return name;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.getChoiceSortingData();
      })();
    },
    // 获取备货分拣架的设置
    getPackageSetting(ymsWarehouseId) {
      let v = this;
      let query = [
        {
          paramKeys: [
            'choiceEnableLeftShelfType',
            'choiceEnableMidShelfType',
            'choiceEnableRightShelfType',
            'choiceLeftShelfType',
            'choiceMidShelfType',
            'choiceRightShelfType'
          ],
          businessId: v.userInfo.userId
        }
      ];
      getCommonSetting(query).then((data) => {
        if (data) {
          // 获取分拣架状态
          function getPickingStatus(val) {
            let keyList = ['choiceEnableLeftShelfType', 'choiceEnableMidShelfType', 'choiceEnableRightShelfType'];
            let obj = {
              choiceEnableLeftShelfType: 'leftBoxsStatus',
              choiceEnableMidShelfType: 'midBoxsStatus',
              choiceEnableRightShelfType: 'rigBoxsStatus'
            };
            if (keyList.includes(val.paramKey)) {
              v[obj[val.paramKey]] = val.paramValue === 'Y';
            }
          }

          // 获取分拣架的数据
          function getPickingSeting(val) {
            let keyList = ['choiceLeftShelfType', 'choiceMidShelfType', 'choiceRightShelfType'];
            if (keyList.includes(val.paramKey)) {
              let value = val.paramValue.split('x');
              let obj = {
                choiceLeftShelfType: ['leftRow', 'leftCol'],
                choiceMidShelfType: ['midRow', 'midCol'],
                choiceRightShelfType: ['rigRow', 'rigCol']
              };
              let statusObj = {
                choiceLeftShelfType: v.leftBoxsStatus,
                choiceMidShelfType: v.midBoxsStatus,
                choiceRightShelfType: v.rigBoxsStatus
              };
              if (statusObj[val.paramKey]) {
                v[obj[val.paramKey][0]] = value[0];
                v[obj[val.paramKey][1]] = value[1];
              }
            }
          }

          data.forEach((item, i) => {
            getPickingStatus(item);
            getPickingSeting(item);
          });
          v.initBox();
        }
      });
    },
    // 初始化拣货框
    initBox() {
      let v = this;
      if (v.leftRow && v.leftCol) {
        for (let i = 1; i <= v.leftRow; i++) {
          for (let j = 1; j <= v.leftCol; j++) {
            let box = {
              boxNo: '1' + i + j,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false // true已完成  false未完成
            };
            v.leftBoxs.push(box);
          }
        }
      }
      if (v.midRow && v.midCol) {
        for (let n = 1; n <= v.midRow; n++) {
          for (let k = 1; k <= v.midCol; k++) {
            let box = {
              boxNo: '2' + n + k,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false
            };
            v.midBoxs.push(box);
          }
        }
      }
      if (v.rigRow && v.rigCol) {
        for (let s = 1; s <= v.rigRow; s++) {
          for (let t = 1; t <= v.rigCol; t++) {
            let box = {
              boxNo: '3' + s + t,
              boxData: null, // 存储包裹信息
              packDataNum: 0, // 已扫描货品种类数
              packageCode: null,
              color: 'background:white',
              boxIsFinish: false // 判断篮子是否满了
            };
            v.rigBoxs.push(box);
          }
        }
      }
    },
    // 获取备货分拣信息
    getChoiceSortingData() {
      let v = this;
      let code = v.$route.query.code;
      v.pickDataNum = 0;
      v.axios.put(api.put_ymsPickingOrder_preparationStartSorting + '?code=' + code).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.getPackageSetting(data.ymsWarehouseId);
            if (data.allChangeLable) {
              v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004799'));
              setTimeout(() => {
                v.$router.push('/wms/sorting');
              }, 300);
              return false;
            } else {
              v.choiceSortingInfo = data;
              v.showNo = data.code;
              // 获取当前作业中的小包信息 （针对于云卖订单已换单之后重新打Temu中间标签的问题）
              v.packetList = data.ymsThirdPlatformPackages || [];
              let pathlist = [
                {name: data.code}
              ];
              let arr = [...v.breadcrumbList, ...pathlist];
              v.breadcrumbList = v.uniqueFunc(arr, 'name');
              v.ymsPickingOrderId = data.ymsPickingOrderId;
              v.orderType = data.orderType;
              // 出库单
              let outboundOrder = _getOrderRelatedList(data.ymsPickingOrderRelatedList); // 排除已移除云卖订单
              v.outboundOrderList = JSON.parse(JSON.stringify(outboundOrder));
              v.handlerOutboundOrder(outboundOrder).then(() => {
                // 拣货单
                v.handlerPickingListData(outboundOrder);
              });
            }
            // 校验出库单中是否存在有已取消的订单(如果存在取消的订单则弹出取消订单提示窗)
            ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [data.ymsPickingOrderId]).then((list) => {
              if (list.length > 0) {
                this.$refs['orderCancelPrompt'].basicData = list;
                this.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
              }
            });
          }
        }
      });

      // 获取正常出库单
      function _getOrderRelatedList(order) {
        let orderList = order || [];
        return orderList.filter(i => i.status === 1);
      }
    },
    // 处理出库单的数据
    handlerOutboundOrder(outboundOrder) {
      let v = this;
      let new_arr = [];
      let ymsPackageGoodList = [];
      let newList = [];
      if (outboundOrder && outboundOrder.length > 0) {
        return new Promise(resolve => {
          // TEMU_P --> 货品订单的分拣逻辑与常规分拣相同，按照出库单维度分拣进框
          if (v.choiceSortingInfo.orderType === 'TEMU_P') {
            newList = v.handerGrouping(outboundOrder, function (item) {
              return [item.packageCode];
            }, 'packageCode');
            if (newList.length > 0) {
              newList.map((talg) => {
                ymsPackageGoodList = talg.data[0].ymsPackageInfo.ymsPackageGoods;
                let ymsPackageInfo = talg.data[0].ymsPackageInfo;
                new_arr.push({
                  packageCode: talg.data[0].packageCode,
                  packageId: talg.data[0].ymsPackageId,
                  printTime: talg.data[0].ymsPackageInfo.printTime,
                  labelPath: talg.data[0].ymsPackageInfo.labelPath,
                  ymsPickingOrderRelatedId: talg.data[0].ymsPickingOrderRelatedId,
                  sortingPackageGoodsResult: handlerData(ymsPackageGoodList, ymsPackageInfo)
                });
              });
              v.packageData = new_arr;
            }

            function handlerData(data, ymsPackageInfo) {
              let new_arr = [];
              if (data.length > 0) {
                data.map((item) => {
                  new_arr.push({
                    packageGoodsId: item.ymsPackageGoodsId,
                    productGoodsId: item.ymsProductGoodsId,
                    quantity: item.quantity,
                    sku: item.ymsSku,
                    title: item.title,
                    variations: item.variations,
                    haveSkuNum: 0,
                    trackingNumber: ymsPackageInfo.trackingNumber,
                    packageCode: ymsPackageInfo.packageCode,
                    ymsPackageInfo: ymsPackageInfo
                  });
                });
                if (new_arr.length > 0) {
                  return new_arr;
                }
              }
            }
          }
          // TEMU_S --> 样品订单需要按照执行发货形成的包裹维度进行分拣，即一个分拣框会对应多个出库单。（根据运单号维度）trackingNumber
          else if (v.choiceSortingInfo.orderType === 'TEMU_S') {
            let list = [];
            outboundOrder.map((item) => {
              let obj = item.ymsPackageInfo;
              obj.ymsPickingOrderRelatedId = item.ymsPickingOrderRelatedId;
              list.push(obj);
            });
            if (list.length > 0) {
              newList = v.handerGrouping(list, function (item) {
                return [item.trackingNumber];
              }, 'trackingNumber');
              console.log('------trackingNumber 当前拣货单中的运单号------', newList);
              if (newList.length > 0) {
                newList.map((talg) => {
                  new_arr.push({
                    packageCode: talg.data[0].packageCode,
                    packageId: talg.data[0].ymsPackageId,
                    printTime: talg.data[0].printTime,
                    labelPath: talg.data[0].labelPath,
                    trackingNumber: talg.trackingNumber,
                    ymsPickingOrderRelatedId: talg.data[0].ymsPickingOrderRelatedId,
                    sortingPackageGoodsResult: handlerData(talg.data)
                  });
                });

                function handlerData(data) {
                  let arr = [];
                  if (data && data.length > 0) {
                    data.map((item) => {
                      item.ymsPackageGoods.map((ele) => {
                        arr.push({
                          packageGoodsId: ele.ymsPackageGoodsId,
                          productGoodsId: ele.ymsProductGoodsId,
                          quantity: ele.quantity,
                          sku: ele.ymsSku,
                          title: ele.title,
                          variations: ele.variations,
                          haveSkuNum: 0,
                          ymsPackageGoodsDetails: ele.ymsPackageGoodsDetails || [],
                          trackingNumber: item.trackingNumber,
                          packageCode: item.packageCode,
                          ymsPickingOrderRelatedId: item.ymsPickingOrderRelatedId,
                          ymsPackageId: item.ymsPackageId
                        });
                      });
                    });
                  }
                  return arr;
                }

                v.packageData = JSON.parse(JSON.stringify(new_arr));
                console.log('------包裹数据------', new_arr);
              }
            }
          }
          resolve();
        });
      }
    },
    // 处理拣货单的数据
    handlerPickingListData(ymsPickingOrderRelatedList, type) {
      let v = this;
      if (ymsPickingOrderRelatedList.length > 0) {
        let pickingList = [];
        // 已换单之后（包含已换单）排除
        let list = ymsPickingOrderRelatedList.filter((item) => {
          return item.ymsPackageInfo.status >= 5;
        });
        if (list.length > 0) {
          list.map((item) => {
            v.packageData.forEach((i, index) => {
              if (i.packageId === item.ymsPackageId) {
                v.packageData.splice(index, 1);
              }
            });
            _setBox(item.ymsPackageInfo);
          });
        }
        let newList = ymsPickingOrderRelatedList.filter((item) => {
          return item.ymsPackageInfo.status < 5;
        });
        if (newList.length > 0) {
          newList.map((item) => {
            let ymsPackageGoods = item.ymsPackageInfo.ymsPackageGoods || [];
            if (ymsPackageGoods.length > 0) {
              ymsPackageGoods.map((ele) => {
                ele.trackingNumber = item.ymsPackageInfo.trackingNumber;
                ele.packageCode = item.ymsPackageInfo.packageCode;
                ele.ymsPickingOrderRelatedId = item.ymsPickingOrderRelatedId;
                ele.ymsPackageId = item.ymsPackageInfo.ymsPackageId;
              });
              pickingList.push(...ymsPackageGoods);
            }
          });
        }
        if (pickingList.length > 0) {
          let new_arr = [];
          const res = new Map();
          let summationList = pickingList.reduce((list, item) => {
            if (res.has(item.ymsProductGoodsId)) {
              res.get(item.ymsProductGoodsId).quantity += item.quantity;
            } else {
              let obj = {...item};
              list.push(obj);
              res.set(item.ymsProductGoodsId, obj);
            }
            return list;
          }, []);
          if (summationList && summationList.length > 0) {
            summationList.map((ele) => {
              new_arr.push({
                haveNum: ele.haveNum || 0, // 拣货单已分拣货品数量
                pickFinishStatus: ele.pickFinishStatus || false, // 拣货单分拣完成状态 false未完成 true已完成
                packageGoodsId: null,
                productGoodsId: ele.ymsProductGoodsId,
                quantity: ele.quantity,
                sku: ele.ymsSku,
                title: ele.title,
                variations: ele.variations,
                trackingNumber: ele.trackingNumber,
                packageCode: ele.packageCode,
                ymsPickingOrderRelatedId: ele.ymsPickingOrderRelatedId,
                ymsPackageId: ele.ymsPackageId
              });
            });
            if (new_arr.length > 0) {
              console.log('=====拣货单列表数据========', new_arr);
              v.pickGoodsData = new_arr;
            }
          }
        }
        v.$forceUpdate();
      }

      // 当云卖订单状态是已换单时，标记对应的拣货篮已经全部拣货完成
      function _setBox(packageInfo) {
        let isAdd = false;
        [...v.leftBoxs, ...v.midBoxs, ...v.rigBoxs].forEach(box => {
          if (!box.boxIsFinish && !isAdd) {
            isAdd = true;
            box.boxIsFinish = true;
            box.replacedOrder = true; // 表示已换单  隐藏 重置移除
            box.boxData = {
              packageCode: packageInfo.packageCode,
              packageId: packageInfo.ymsPackageId,
              sortingPackageGoodsResult: packageInfo.ymsPackageGoods.map(i => {
                return {
                  haveSkuNum: i.quantity,
                  quantity: i.quantity,
                  sku: i.ymsSku,
                  packageCode: packageInfo.packageCode,
                  packageGoodsId: i.ymsPackageGoodsId,
                  productGoodsId: i.ymsProductGoodsId,
                  title: i.title,
                  variations: i.variations
                };
              })
            };
            box.color = 'background:#00B150;cursor:pointer;'; // 绿色
            if (v.choiceSortingInfo.orderType === 'TEMU_S') {
              let arr = [];
              if (box.boxData) {
                let list = box.boxData.sortingPackageGoodsResult;
                list.map((item) => {
                  v.choiceSortingInfo.ymsPickingOrderDetails.map((talg) => {
                    if (item.productGoodsId === talg.ymsProductGoodsId) {
                      item['labelPath'] = talg.ymsThirdPlatformProductLabel ? talg.ymsThirdPlatformProductLabel.labelPath : null;
                    }
                  });
                  arr.push(item.packageCode);
                });
                v.packageCodeList = v.uniqueFunc(arr);
              }
            }
          }
        });
      }
    },
    clearSku() {
      this.sku = this.$refs.curSku.$refs.input.value;
      this.$refs.curSku.$refs.input.value = '';
    },
    // 扫描SKU/货品身份码
    skuStart() {
      let v = this;
      clearTimeout(v.clearTime);
      v.$nextTick(() => {
        v.$refs['curSku'].$refs.input.value = '';
      });
      if (this.state === 2) {
        // 先调用方法关掉所有灯
        light.closeAll();
      }
      if (v.greenLightNum !== null && v.greenLightStatus) {
        light.openGreen(v.greenLightNum); // 绿灯常亮 当前篮子已装满
        v.greenLightStatus = false;
      }
      let validObj = v.hasBox();
      if (!validObj.isPickGoods) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004800'));
        v.showProductGoods = false;
        return;
      }
      if (!validObj.hasBox) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004801'));
        return;
      }
      v.showProductGoods = false;
      v.pickGoodsData.forEach((n, i) => {
        if (v.sku === n.sku || v.sku === n.upc) {
          if (n.quantity === n.haveNum) {
            // 判断拣货单中该sku是否已完成分拣
            return false;
          }
          if (n.quantity === n.haveNum + 1) {
            // 记录当前拣货单完成分拣的情况
            console.log('SKU:' + v.sku + '分拣完成');
            v.pickDataNum += 1;
            n.pickFinishStatus = true;
            // 全部分拣完毕
            if (v.pickDataNum === v.pickGoodsData.length) {
              v.isFinishStatus = true; // 显示全部完成分拣提示信息
            }
          }
          v.showProductGoods = true;
          v.tabName = 'packTab'; // 若sku有效，显示出库单
          v.packDisabled = false; // 关掉disabled,显示出库单
          v.productGoods = n;
          n.haveNum += 1;
          v.selectBox();
          v.$nextTick(() => {
            v.scrollToIndex();
          });
        }
      });
      // 高亮当前行
      let data = v.curBox.boxData.sortingPackageGoodsResult;
      if (data) {
        data.forEach((m, t) => {
          if (m.sku === v.sku || m.upc === v.sku) {
            v.rowClassIndex = t;
          }
        });
      }
    },
    // 检查是否有没有分配完的出库单
    packageCodeHasSku() {
      let hasTrue = false;
      let v = this;
      [...v.leftBoxs, ...v.midBoxs, ...v.rigBoxs].forEach(i => {
        if (i.boxData && i.boxData.sortingPackageGoodsResult) {
          i.boxData.sortingPackageGoodsResult.forEach(j => {
            if (j.sku === v.sku && j.haveSkuNum < j.quantity) {
              hasTrue = true;
            }
          });
        }
      });
      return hasTrue;
    },
    /**
     * @Description:判断是否有可用拣货篮
     * @date: 2020/11/13 15:20
     * @params:
     */
    hasBox() {
      let hasBox = true;
      let isPickGoods = false; // 是当前拣货单商品
      let firstJoin = false; // 是否第一次拣货
      let v = this;
      v.pickGoodsData.forEach((n, i) => {
        if (v.sku === n.sku || v.sku === n.upc) {
          if (n.haveNum === 0) {
            firstJoin = true;
          }
          isPickGoods = true;
        }
      });
      if (isPickGoods) {
        // 是当前拣货单商品
        // 先判断是否第一次加入
        if (firstJoin) {
          // 判断是否存在在正在拣货的篮子
          if (v.packageCodeHasSku()) {
            hasBox = true;
          } else {
            // 判断是否有空篮子
            hasBox = v.leftBoxs.some(i => i.boxData === null) ||
              v.midBoxs.some(i => i.boxData === null) ||
              v.rigBoxs.some(i => i.boxData === null);
          }
        }
      }
      return {
        hasBox: hasBox,
        isPickGoods: isPickGoods
      };
    },
    // 选择符合条件的箱子
    selectBox() {
      if (!this.findBox(this.leftBoxs)) {
        if (!this.findBox(this.midBoxs)) {
          this.findBox(this.rigBoxs);
        }
      }
    },
    // 根据指定的箱子集合查找有效的箱子
    findBox(boxList) {
      let v = this;
      console.log('找篮子:findBox---', boxList);
      if (boxList.length) {
        let isF = false;
        for (let i = 0; i < boxList.length; i++) {
          let box = boxList[i];
          if (box.boxData && !box.boxIsFinish) {
            let sortingPackageGoodsResult = box.boxData.sortingPackageGoodsResult;
            for (let m = 0; m < sortingPackageGoodsResult.length; m++) {
              let k = sortingPackageGoodsResult[m];
              if ((v.sku === k.sku || v.sku === k.upc) && k.haveSkuNum < k.quantity) {
                // 当前篮子需要这个sku
                isF = true;
                k.haveSkuNum += 1;
                v.curBox = box;
                if (k.quantity === k.haveSkuNum) {
                  box.packDataNum++;
                  if (sortingPackageGoodsResult.length === box.packDataNum) {
                    box.color = 'background:#00B150;cursor:pointer;'; // 绿色
                    box.boxIsFinish = true; // 当前篮子已完成分拣
                    if (this.state === 2) {
                      light.flashGreen(box.boxNo); // 绿灯闪烁 当前货品是这个篮子的最后一个
                      v.greenLightNum = box.boxNo;
                      v.greenLightStatus = true;
                    }
                  }
                }
                // 样品单需要打印标签
                if (v.orderType === 'TEMU_S') {
                  console.log('=====k===00000====', k);
                  let ymsPackageGoodsDetails = k.ymsPackageGoodsDetails || [];
                  if (ymsPackageGoodsDetails.length === 1) {
                    if (ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel) {
                      let labelPath = ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel.labelPath || null;
                      v.printLabelBtn(labelPath, '1', box.boxData, null, box.boxIsFinish);
                    } else {
                      v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004802'));
                      return false;
                    }
                  } else {
                    let labelPath;
                    let haveSkuNum = k.haveSkuNum;
                    let sum = 0; // 用于累加 quantity
                    for (let item of ymsPackageGoodsDetails) {
                      if (item.quantity >= haveSkuNum) {
                        labelPath = item.ymsThirdPlatformProductLabel.labelPath || null;
                        return;
                      } else {
                        sum += item.quantity; // 累加 quantity
                        if (sum >= haveSkuNum) {
                          labelPath = item.ymsThirdPlatformProductLabel.labelPath || null;
                          return;
                        }
                      }
                    }
                    v.printLabelBtn(labelPath, '1', box.boxData, null, box.boxIsFinish);
                  }
                }
                return true;
              }
            }
          }
        }
        if (isF) return;
        for (let i = 0; i < boxList.length; i++) {
          let box = boxList[i];
          if (!box.boxData) {
            // 判断篮子是否为空
            box.boxData = v.getPackageData(box);
            // 已出库处理
            box.boxData.sortingPackageGoodsResult.forEach(p => {
              if (p.quantity === 0) {
                // 都已出库
                box.packDataNum++;
              }
            });
            box.color = 'background:#9BC053;cursor:pointer;';
            if (this.state === 2) {
              light.flashRed(box.boxNo); // 红灯闪烁 篮子刚分配且当前货品不是最后一个
            }
            // 未完成分拣
            let sortingPackageGoodsResult = box.boxData.sortingPackageGoodsResult;
            for (let m = 0; m < sortingPackageGoodsResult.length; m++) {
              let k = sortingPackageGoodsResult[m];
              if ((v.sku === k.sku || v.sku === k.upc) && k.haveSkuNum < k.quantity) {
                // 当前篮子需要这个sku
                k.haveSkuNum += 1;
                v.curBox = box;
                if (k.quantity === k.haveSkuNum) {
                  box.packDataNum++;
                  if (sortingPackageGoodsResult.length === box.packDataNum) {
                    box.color = 'background:#00B150;cursor:pointer;';
                    box.boxIsFinish = true; // 当前篮子已完成分拣
                    if (this.state === 2) {
                      light.flashGreen(box.boxNo); // 绿灯闪烁 当前货品是这个篮子的最后一个
                      v.greenLightNum = box.boxNo;
                      v.greenLightStatus = true;
                    }
                  }
                }
                // 样品单需要打印标签
                if (v.orderType === 'TEMU_S') {
                  console.log('=====k===11111====', k);
                  let ymsPackageGoodsDetails = k.ymsPackageGoodsDetails || [];
                  if (ymsPackageGoodsDetails.length === 1) {
                    if (ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel) {
                      let labelPath = ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel.labelPath || null;
                      v.printLabelBtn(labelPath, '1', box.boxData, null, box.boxIsFinish);
                    } else {
                      v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004802'));
                      return false;
                    }
                  } else {
                    let labelPath;
                    let haveSkuNum = k.haveSkuNum;
                    let sum = 0; // 用于累加 quantity
                    for (let item of ymsPackageGoodsDetails) {
                      if (item.quantity >= haveSkuNum) {
                        labelPath = item.ymsThirdPlatformProductLabel.labelPath || null;
                        return;
                      } else {
                        sum += item.quantity; // 累加 quantity
                        if (sum >= haveSkuNum) {
                          labelPath = item.ymsThirdPlatformProductLabel.labelPath || null;
                          return;
                        }
                      }
                    }
                    v.printLabelBtn(labelPath, '1', box.boxData, null, box.boxIsFinish);
                  }
                }
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    // 获取当前sku的包裹信息
    getPackageData(box) {
      let v = this;
      for (let i = 0; i < v.packageData.length; i++) {
        for (let j = 0; j < v.packageData[i].sortingPackageGoodsResult.length; j++) {
          if (v.sku === v.packageData[i].sortingPackageGoodsResult[j].sku || v.sku === v.packageData[i].sortingPackageGoodsResult[j].upc) {
            let temp = JSON.parse(JSON.stringify(v.packageData[i]));
            box.delPackData = v.packageData.splice(i, 1); // 存起来方便在重置包裹时使用
            console.log('获取当前扫描sku的信息---', temp);
            return temp;
          }
        }
      }
      return null;
    },
    // 结束本次分拣
    pickEndSortingBtn() {
      let v = this;
      let list = []; // 未完成分拣包裹列表
      if (v.packageData.length) {
        // packageData里若是有数据则表示有包裹未分配篮子
        v.packageData.forEach((m, t) => {
          m.noBoxNo = true; // 增加noBoxNo表示该包裹未分配拣货框 true未分配 false已分配
          m.sortingPackageGoodsResult.map((item) => {
            item.noBoxNo = m.noBoxNo;
          });
          list.push(m);
        });
      }

      function basketData(item) {
        if (item.boxData) {
          // 先判断篮子是否为空
          if (!item.boxIsFinish) {
            // 判断篮子是否未完成分拣 false未完成 true已完成
            item.noBoxNo = false; // 增加noBoxNo表示该包裹未分配拣货框 true未分配 false已分配
            item.packageId = item.boxData.packageId;
            item.packageCode = item.boxData.packageCode;
            item.ymsPickingOrderRelatedId = item.boxData.ymsPickingOrderRelatedId;
            list.push(item);
            if (v.state === 2) {
              light.openRed(item.boxNo); // 红灯常亮 还有篮子未分配
            }
          }
        }
      }

      if (v.leftBoxs.length) {
        v.leftBoxs.forEach((item) => {
          basketData(item);
        });
      } else if (v.midBoxs.length) {
        v.midBoxs.forEach((item) => {
          basketData(item);
        });
      } else if (v.rigBoxs.length) {
        v.rigBoxs.forEach((item) => {
          basketData(item);
        });
      }
      let pos = []; // 未完成分拣货品列表
      v.pickGoodsData.forEach((n, i) => {
        if (!n.pickFinishStatus) {
          // 未完成分拣
          pos.push(n);
        }
      });
      if (!list.length && !pos.length) {
        // 当这两个数组都没有数据时，表示无异常
        v.sortingEnd();
      } else {
        // 反正则表示有异常数据
        let nopickData = [];
        list.map((item) => {
          if (!item.printTime || item.boxData.printTime === null) {
            nopickData.push(item);
          }
        });
        v.$refs['endSorting'].pickGoodsData = v.pickGoodsData;
        v.$refs['endSorting'].initEndSortingData(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004803'), v.showNo, v.ymsPickingOrderId,
          pos, nopickData, v.choiceSortingInfo.orderType);
      }
    },
    // 将该包裹重置为未开始分拣
    restPackage() {
      let v = this;
      v.sku = null;
      v.$nextTick(() => {
        v.$refs['curSku'].$refs.input.value = '';
      });
      v.curBox.boxData.sortingPackageGoodsResult.forEach((n, i) => {
        v.pickGoodsData.forEach((m, t) => {
          // m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
          if (((n.sku === m.sku && n.sku) || (n.upc === m.upc && n.upc)) && n.haveSkuNum > 0) {
            m.haveNum -= n.haveSkuNum;
            if (m.pickFinishStatus) {
              v.pickDataNum -= 1;
            }
            m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
          }
        });
      });
      v.curBox.boxData = '';
      v.curBox.boxIsFinish = false; // 把篮子的状态标记为未完成
      v.curBox.packDataNum = 0;
      v.packageData.push(v.curBox.delPackData[0]);
      v.tabName = 'pickTab'; // 显示拣货单
      v.packDisabled = true; // 打开disabled,隐藏出库单
      v.curBox.color = 'background:white';
      v.isFinishStatus = false; // 隐藏全部完成分拣提示信息
    },
    // 将该包裹从当前拣货单中移除等待生成新的拣货单
    removePackage() {
      let v = this;
      let ymsPickingOrderRelatedId = v.curBox.boxData.ymsPickingOrderRelatedId;
      v.axios.delete(api.delete_ymsPickingOrderRelated + ymsPickingOrderRelatedId).then(response => {
        if (response.data.code === 0) {
          v.curBox.boxData.sortingPackageGoodsResult.forEach((n, i) => {
            // 先拿到该包裹货品数据
            v.pickGoodsData.forEach((m, t) => {
              // 再从拣货单中删除对应的数量
              if ((n.sku === m.sku && n.sku) || (n.upc === m.upc && m.upc)) {
                if (m.pickFinishStatus) {
                  v.pickDataNum -= 1;
                  m.pickFinishStatus = false; // 拣货单分拣完成状态 false未完成 true已完成
                }
                if (m.quantity - n.quantity) {
                  // 拣货单中货品数量减去出库单货品数量，若为0则从拣货单中删除
                  m.haveNum -= n.haveSkuNum;
                  m.quantity -= n.quantity;
                } else {
                  v.pickGoodsData.splice(t, 1);
                }
                v.isPickFinishStatus();
              }
            });
          });
          v.$refs['curSku'].$refs.input.value = null;
          v.sku = null;
          v.curBox.boxData = '';
          v.curBox.boxIsFinish = false; // 把篮子的状态标记为未完成
          v.tabName = 'pickTab'; // 显示拣货单
          v.packDisabled = true; // 打开disabled,隐藏出库单
          v.curBox.color = 'background:white';
          v.curBox.packDataNum = 0;
        }
      });
    },
    // 移除包裹的时候是否完成拣货状态
    isPickFinishStatus() {
      this.pickDataNum = 0;
      this.pickGoodsData.forEach(i => {
        if (i.quantity === i.haveNum) {
          i.pickFinishStatus = true;
          this.pickDataNum++;
        }
      });
    },
    // 点击侧篮子显示出库单信息
    showBoxInfo(typeData, index) {
      let v = this;
      if (v[typeData][index].boxData) {
        v.curBox = v[typeData][index];
        v.tabName = 'packTab'; // 显示出库单
        v.$forceUpdate();
      }
    },
    // 分拣完成 无异常
    sortingEnd() {
      let v = this;
      let obj = {
        ymsPickingOrderRelatedIds: [],
        ymsPickingOrderId: v.ymsPickingOrderId
      };
      v.overSorting(obj);
    },
    // 强制结束 有异常
    endsortingBtn(obj) {
      this.overSorting(obj);
    },
    // 结束分拣
    overSorting(obj) {
      let v = this;
      // 校验出库单中是否存在有已取消的订单(如果存在取消的订单则弹出取消订单提示窗)
      ymsVerifyPicking(api.put_ymsPickingOrder_checkPickingOrder, [v.ymsPickingOrderId]).then((list) => {
        if (list.length > 0) {
          v.$refs['orderCancelPrompt'].basicData = list;
          v.$refs['orderCancelPrompt'].orderCancelPromptModal = true;
        } else {
          obj.updateYmsPickingOrderRelatedVos = [];
          obj.insertYmsThirdPackageGoodBos = [];
          // 货品订单需要传篮子编号
          if (v.choiceSortingInfo.orderType === 'TEMU_P') {
            let newList = [...v.leftBoxs, ...v.midBoxs, ...v.rigBoxs];
            if (newList.length > 0) {
              newList.map((item) => {
                if (item.boxData && Object.keys(item.boxData).length > 0) {
                  obj.updateYmsPickingOrderRelatedVos.push({
                    pickingBasketNo: item.boxNo,
                    ymsPickingOrderRelatedId: item.boxData.ymsPickingOrderRelatedId
                  });
                }
              });
            }
          } else {
            if (v.pickGoodsData.length > 0) {
              v.pickGoodsData.map((item) => {
                if (v.packetList.length > 0) {
                  v.packetList.map((ele) => {
                    if (item.ymsPackageId === ele.ymsPackageId) {
                      obj.insertYmsThirdPackageGoodBos.push({
                        quantity: item.haveNum,
                        ymsProductGoodsId: item.productGoodsId,
                        ymsThirdPlatformPackageId: ele.ymsThirdPlatformPackageId
                      });
                    }
                  });
                }
              });
            }
          }
          v.axios.put(api.put_ymsPickingOrder_endSorting, obj, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              setTimeout(() => {
                v.$router.push('/wms/sorting');
              }, 800);
            }
          });
        }
      });
    },
    // 移除已取消的出库单成功之后
    updateDeliveryData(obj) {
      let v = this;
      if (obj) {
        if (obj.allDelete === 1) {
          v.$Modal.info({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004804'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004805'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732'),
            onOk: () => {
              v.$router.push('/wms/sorting');
            }
          });
        } else {
          v.getChoiceSortingData();
        }
      }
    },
    // 高亮当前扫描sku的数据
    rowClassName(row, index) {
      let v = this;
      if (index === v.rowClassIndex) {
        return 'demo-table-info-row';
      } else {
        return '';
      }
    },
    // 扫描sku 之后，让滚动条滚动到指定的sku位置
    scrollToIndex() {
      let v = this;
      if (v.$refs['tableDom']) {
        let tableEl = v.$refs['tableDom'].$el.querySelector('.ivu-table-body');
        let scrollHeight = tableEl.scrollHeight;
        let length = v.curBox.boxData.sortingPackageGoodsResult.length;
        if (scrollHeight) {
          let rowHeight = Math.floor(scrollHeight / length);
          let scrollTop = v.rowClassIndex * rowHeight; // 计算需要滚动的距离
          setTimeout(() => {
            tableEl.scrollTop = scrollTop;
          }, 800);
        }
      }
    },
    // 打印标签
    printLabelBtn(obj, id, data, orderBy, boxIsFinish) {
      let v = this;
      if (obj) {
        printHtmlUrl(obj, id).then(response => {
          if (response.printType === 'cainiao') {
            v.sortingFinishPrint(data);
            return;
          }
          let jsonObj = response;
          if (jsonObj.content) {
            jsonObj.content = encodeURIComponent(jsonObj.content);
          }
          let originPostId = id;
          let instance = v.axios.create({
            timeout: 3000,
            headers: {
              'Content-Type': 'multipart/form-data; charset=UTF-8'
            }
          });
          delete v.axios.defaults.headers.post['X-Requested-With'];
          instance.post('http://localhost:10099/print', qs(jsonObj)).then(response => {
            if (response.status === 200) {
              // v.sortingFinishPrint(data);
              v.startPrintMonitor(jsonObj, originPostId, data, orderBy, boxIsFinish);
            }
          }).catch((err) => {
            let fileName = '/tool/TongtoolPrinter.exe';
            downloadControl(fileName).then(() => {
              v.tableLoading = false;
            });
          });
        });
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004149'));
        return false;
      }
    },
    startPrintMonitor(jsonObj, postId, data, orderBy, boxIsFinish) {
      let v = this;
      let obj = {
        packageIds: [postId]
      };
      if (orderBy) {
        obj.printOrderBy = orderBy;
      }
      delete jsonObj.content;
      delete v.axios.defaults.headers.post['X-Requested-With'];
      v.axios.jsonp('http://localhost:10099/printResult?' + qs(jsonObj)).then(response => {
        console.log('=====打印的结果集====', response.data, '===boxIsFinish====', boxIsFinish);
        if (response.data === '0') {
          v.clearTime = setTimeout(function () {
            v.$nextTick(() => {
              v.$refs.curSku.$refs.input.value = '';
            });
            v.startPrintMonitor(jsonObj, postId, data, orderBy, boxIsFinish);
          }, 500);
        } else if (response.data === '2') {
          document.getElementById('sortingSku').focus();
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004806'));
        } else {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004807'));
          // 当前篮子已完成分拣，直接打印Temu中间标签
          setTimeout(() => {
            if (boxIsFinish) {
              v.printTemuMiddleLabelBtn().then((value) => {
                if (value) {
                  v.sortingFinishPrint(data);
                }
              });
              console.log('---------打印Temu中间标签-----', boxIsFinish);
            }
          }, 2000);
        }
      });
    },
    sortingFinishPrint(data) {
      let v = this;
      if (data) {
        let list = data.sortingPackageGoodsResult || [];
        let ymsPickingOrderRelatedIds = [];
        if (list.length > 0) {
          list.map((item) => {
            ymsPickingOrderRelatedIds.push(item.ymsPickingOrderRelatedId);
          });
        }
        if (ymsPickingOrderRelatedIds.length > 0) {
          let newList = v.uniqueFunc(ymsPickingOrderRelatedIds);
          v.axios.put(api.put_ymsPickingOrderRelated_markChangedLabel, newList).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004808'));
            }
          });
        }
      }
    },
    // 处理列表字段
    handleColumns(val) {
      let v = this;
      let columns = [
        {
          title: 'NO',
          width: 70,
          key: 'index',
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004793'),
          key: 'skuInfo',
          minWidth: 145,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('div', {class: 'mt5 mb5', style: {color: '#008000'}}, params.row.sku),
              h('div', {class: 'mt5 mb5'}, params.row.title),
              h('div', {class: 'mt5 mb5'}, params.row.variations)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004809'),
          key: 'quantity',
          minWidth: 90,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004810'),
          key: 'haveSkuNum',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004811'),
          key: 'sortingQuantity',
          minWidth: 100,
          align: 'center',
          render: (h, params) => {
            let sortingQuantity = params.row.quantity - params.row.haveSkuNum;
            return h('span', {
              class: 'redColor'
            }, sortingQuantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          key: 'options',
          width: 95,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004812'),
                    show: true,
                    clickFn: () => {
                      console.log('======params.row======', params.row);
                      let ymsPackageGoodsDetails = params.row.ymsPackageGoodsDetails || [];
                      if (ymsPackageGoodsDetails.length === 1) {
                        if (ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel) {
                          let labelPath = ymsPackageGoodsDetails[0].ymsThirdPlatformProductLabel.labelPath || null;
                          v.printLabelBtn(labelPath, '1', {sortingPackageGoodsResult: [{...params.row}]}, null);
                        } else {
                          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004802'));
                          return false;
                        }
                      } else {
                        v.ymsPackageGoodsDetailsList = ymsPackageGoodsDetails;
                        let obj = v.curBox.boxData.sortingPackageGoodsResult[params.index];
                        v.sortingPackageGoodsResult = {sortingPackageGoodsResult: [obj]};
                        v.platformItemSkuLabelPathModal = true;
                      }
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      if (val === 'TEMU_S') {
        this.deliveryOrderColumn = columns;
      } else {
        this.deliveryOrderColumn = columns.filter((item) => {
          return item.key !== 'options';
        });
      }
    },
    // 扫描sku创建小包
    getCreatePacket() {
      let v = this;
      let ymsPackageIds = [];
      if (v.outboundOrderList.length > 0) {
        v.outboundOrderList.map((item) => {
          ymsPackageIds.push(item.ymsPackageId);
        });
      }
      let query = {
        ymsPackageIds: v.uniqueFunc(ymsPackageIds),
        ymsPickingOrderId: v.ymsPickingOrderId
      };
      if (ymsPackageIds.length > 0 && v.packetList.length <= 0) {
        v.axios.post(api.post_ymsPickingOrder_preparationStartSortingScanSku, query).then(res => {
          if (res.data.code === 0) {
            v.createTalg = false;
            let data = res.data.datas;
            if (data) {
              v.packetList = data.ymsThirdPlatformPackages || [];
            }
          }
        });
      }
    },
    // 打印Temu中间标签
    printTemuMiddleLabelBtn() {
      let v = this;
      let transferCode = '';
      let trackingNumber = v.curBox.boxData.trackingNumber;
      return new Promise((resolve) => {
        if (v.packetList.length > 0) {
          v.packetList.map((item) => {
            if (item.trackingNumber === trackingNumber) {
              transferCode = item.transferCode;
            }
          });
          if (transferCode) {
            v.axios.post(api.post_ymsPickingOrder_printMidLabel + `?transferCode=${transferCode}`, null,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
              if (res.data.code === 0) {
                let data = res.data.datas;
                if (data) {
                  v.commonPrint(data, '1', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004813'));
                  resolve(true);
                } else {
                  resolve(false);
                  v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004814'));
                  return false;
                }
              }
            });
          }
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004815'));
          return false;
        }
      });
    },
    // 监听弹窗
    platformItemSkuLabelPathChange(value) {
      if (!value) {
        this.platformItemSku = null;
        this.ymsPackageGoodsDetailsList = [];
        this.sortingPackageGoodsResult = {};
      }
    },
    // 打印商品标签
    platformItemSkuLabelPathBtn() {
      let list = this.ymsPackageGoodsDetailsList.filter((item) => {
        return item.platformItemSku === this.platformItemSku;
      });
      if (list.length >0) {
        let ymsThirdPlatformProductLabel = list[0].ymsThirdPlatformProductLabel;
        if (ymsThirdPlatformProductLabel) {
          let labelPath = ymsThirdPlatformProductLabel.labelPath || null;
          this.printLabelBtn(labelPath, '1', this.sortingPackageGoodsResult, null);
        }
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004802'));
        return false;
      }
    }
  },
  watch: {
    // 监听订单类型
    'choiceSortingInfo.orderType': {
      handler(val) {
        this.handleColumns(val);
      },
      immediate: true,
      deep: true
    },
    // 当前扫描的包裹
    'curBox': {
      handler(data) {
        if (data) {
          let v = this;
          console.log('_____当前扫描的包裹________--', data);
          let arr = [];
          if (v.choiceSortingInfo.orderType === 'TEMU_S') {
            if (data.boxData) {
              let list = data.boxData.sortingPackageGoodsResult;
              list.map((item) => {
                arr.push(item.packageCode);
              });
              v.packageCodeList = v.uniqueFunc(arr);
              if (v.sku && v.createTalg) {
                v.getCreatePacket();
              }
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    endSortingModal,
    orderCancelPromptModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  background-color: #fff;
  padding: 0 10px 10px 10px;

  .breadcrumb_box {
    padding: 12px 0 12px 0;
  }

  .header_options_box {
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    background-color: #f79646;
    height: 40px;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    font-size: 16px;

    .user_name {
      display: inline-block;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      margin-right: 30px;
    }
  }

  .skuInput_box {
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    padding: 18px 10px;
    background-color: rgba(43, 120, 228, 1);
    margin: 12px 0;
  }

  .choiceSortingInfo_box {
    width: 100%;
    height: 457px;
    padding-top: 20px;
    background-color: rgba(215, 215, 215, 1);

    .productInfo_box {
      width: 96%;
      height: 200px;
      margin: 0 auto;
      padding: 15px 30px;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;

      .img_styles {
        vertical-align: middle;
        width: auto;
        max-width: 180px;
        height: 130px;
        cursor: pointer;
        display: inline-block;
        margin-right: 30px;
      }
    }

    .warnBox {
      width: 80%;
      height: 400px;
      border: 1px solid #717274;
      margin-left: 5%;
      background-color: #fff;

      .title {
        height: 30px;
        background: #dee6ee;
        padding: 5px;
        border-bottom: 1px solid #c5d2e1;
      }

      .content {
        width: 94%;
        height: 200px;
        background: #faeed8;
        border: 1px solid #dcddda;
        padding: 15px;
        margin: 30px auto 20px;
      }

      .warnBtn {
        width: 200px;
        height: 25px;
        line-height: 25px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        background-color: #aaa;
        margin: 20px auto;
      }
    }

    .productBox {
      width: 300px;
      height: 170px;
      border: 1px solid #000;
      font-size: 50px;
      text-align: center;
      line-height: 170px;
      font-weight: bold;
    }
  }

  .packTab_box {
    height: 485px;
    background-color: rgba(215, 215, 215, 1);

    .showBoxNo {
      width: 80px;
      height: 40px;
      border: 1px solid #000;
      margin-bottom: 10px;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
    }

    /deep/ .ivu-table .demo-table-info-row td {
      background-color: #ebf7ff;
    }
  }

  .boxs_conter {
    width: 99%;
    margin: 10px auto;

    .pickBox {
      float: left;
      width: 18%;
      height: 50px;
      margin-top: 5px;
      margin-bottom: 5px;
      border: 1px solid #000;
      font-weight: bold;
      margin-right: 2%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .icon_styles {
        border-right: 15px solid transparent;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
}
</style>